import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

function PopupEndAssessemnt({ setClick, handleConfirm, handleCancel }) {
  return (
    <div className="published_Deative_transprant_body">
      <div
        className="published_Deative_preview_container"
        style={{
          width: "460px",
          maxWidth: "92vw",
          height: "auto",
          padding: "32px 28px 24px",
          borderRadius: "16px",
          background: "#fff",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          position: "relative",
        }}
      >
        {/* Close icon */}
        <img
          className="deactive_closeBtn"
          src="/images/cross-circle3.svg"
          alt="close"
          onClick={() => setClick(false)}
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            width: "26px",
            height: "26px",
            cursor: "pointer",
            opacity: 0.7,
            transition: "opacity 0.2s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.7)}
        />

        {/* Warning icon */}
        <div
          style={{
            width: "64px",
            height: "64px",
            borderRadius: "50%",
            background: "#FFF4E5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "18px",
          }}
        >
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            style={{ fontSize: "28px", color: "#F77F00" }}
          />
        </div>

        {/* Title */}
        <h3
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: 600,
            color: "#1F2937",
          }}
        >
          End Assessment?
        </h3>

        {/* Message */}
        <p
          style={{
            margin: "10px 0 26px",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#6B7280",
          }}
        >
          Are you sure you want to end the assessment? This action cannot be
          undone.
        </p>

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <button
            onClick={handleCancel}
            style={{
              flex: 1,
              padding: "10px 16px",
              borderRadius: "10px",
              border: "1px solid #E5E7EB",
              background: "#fff",
              color: "#374151",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#F9FAFB")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
          >
            No, Cancel
          </button>
          <button
            onClick={handleConfirm}
            style={{
              flex: 1,
              padding: "10px 16px",
              borderRadius: "10px",
              border: "none",
              background: "#DC2626",
              color: "#fff",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#B91C1C")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#DC2626")}
          >
            Yes, End
          </button>
        </div>
      </div>
    </div>
  );
}

export default PopupEndAssessemnt;
